export const SELECTED_SEGMENT_STORAGE_KEY = 'maia:selectedSegment';
export const SEGMENT_SELECTION_CHANGED_EVENT = 'maia:selectedSegmentChanged';

const SEGMENT_GROUP_PATTERN = /^(FIXTER|MOTRIO|RENAULT)[-_][A-Z]{2}$/;

export const normalizeSegment = segment => segment.toUpperCase().replace('_', '-');

export const getSelectableSegmentsFromGroups = (groups = []) =>
  [...new Set(
    groups
      .map(group => normalizeSegment(group))
      .filter(group => SEGMENT_GROUP_PATTERN.test(group))
  )];

export const getStoredSelectedSegment = () => localStorage.getItem(SELECTED_SEGMENT_STORAGE_KEY);

export const getSelectedSegmentFromGroups = (groups = []) => {
  const segments = getSelectableSegmentsFromGroups(groups);
  const storedSegment = getStoredSelectedSegment();

  return segments.includes(storedSegment) ? storedSegment : segments[0] || null;
};

export const setStoredSelectedSegment = (segment) => {
  const previousSegment = getStoredSelectedSegment();

  if (segment) {
    localStorage.setItem(SELECTED_SEGMENT_STORAGE_KEY, segment);
  } else {
    localStorage.removeItem(SELECTED_SEGMENT_STORAGE_KEY);
  }

  // Only notify listeners when the value actually changed. Persisting the
  // resolved default on mount must not trigger a redundant re-fetch in
  // listeners (e.g. GarageListPage) that already loaded the same segment.
  if (segment !== previousSegment) {
    window.dispatchEvent(new CustomEvent(SEGMENT_SELECTION_CHANGED_EVENT, { detail: { segment } }));
  }
};
